(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-brands"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv-brand-marquee')){customElements.define('sv-brand-marquee',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const button=this.querySelector('[data-brand-toggle]');if(reduced){button.hidden=true;this.dataset.paused='true';return}button?.addEventListener('click',()=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);button.textContent=paused?this.dataset.playLabel:this.dataset.pauseLabel;button.setAttribute('aria-pressed',String(paused))})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-budget"] && !Shopify.designMode) return;
  try {
    
function initSvBudget(){document.querySelectorAll('[data-sv-budget]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-price]')];const count=root.querySelector('[data-count]');const update=(max)=>{let shown=0;cards.forEach(card=>{card.hidden=max>0&&Number(card.dataset.price)>max;if(!card.hidden)shown++});if(count)count.textContent=shown+' '+count.dataset.label;const empty=root.querySelector('[data-empty]');if(empty)empty.hidden=shown>0};root.querySelectorAll('[data-max]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-max]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update(Number(button.dataset.max))}));update(0)})}initSvBudget();document.addEventListener('shopify:section:load',initSvBudget);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv-home-slider')){customElements.define('sv-home-slider',class extends HTMLElement{
connectedCallback(){if(!this.ready){this.ready=true;this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1));this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.dot))));this.querySelector('[data-toggle]')?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()});this.addEventListener('pointerenter',()=>{this.hovered=true});this.addEventListener('pointerleave',()=>{this.hovered=false});this.addEventListener('focusin',e=>{if(!e.target.closest('[data-toggle]')){this.paused=true;this.sync()}});this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.show(this.index-1)}if(e.key==='ArrowRight'){e.preventDefault();this.show(this.index+1)}});this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.paused=true;this.show(i);this.sync()}})}this.sync();clearInterval(this.timer);this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!document.hidden&&this.slides.length>1)this.show(this.index+1)},Number(this.dataset.interval)||6000)}
disconnectedCallback(){clearInterval(this.timer)}
show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===this.index)));const count=this.querySelector('[data-counter]');if(count)count.textContent=(this.index+1)+' / '+this.slides.length}
sync(){const toggle=this.querySelector('[data-toggle]');if(toggle){const label=this.paused?this.dataset.playLabel:this.dataset.pauseLabel;toggle.textContent=label;toggle.setAttribute('aria-label',label)}}
})}

  } catch(e) { console.error(e); }
})();
})();
